<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="banner">
      <el-carousel height="550px" :interval="5000" arrow="always" indicator-position="none">
        <el-carousel-item>
          <div class="carousel-content" style="background: linear-gradient(135deg, #1976D2, #64B5F6);">
            <div class="carousel-text">
              <h1>智慧教育解决方案</h1>
              <h3>为教育行业提供多方位的信息化服务</h3>
              <el-button type="primary" size="large" round @click="$router.push('/products')">了解更多</el-button>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel-content" style="background: linear-gradient(135deg, #283593, #5C6BC0);">
            <div class="carousel-text">
              <h1>教育信息化整体解决方案</h1>
              <h3>服务教育局与学校，促进教育现代化</h3>
              <el-button type="primary" size="large" round @click="$router.push('/contact')">联系我们</el-button>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel-content" style="background: linear-gradient(135deg, #00695C, #4DB6AC);">
            <div class="carousel-text">
              <h1>教育数据智能分析</h1>
              <h3>挖掘教育数据价值，提供精准教学决策</h3>
              <el-button type="primary" size="large" round @click="$router.push('/products')">查看详情</el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 公司简介 -->
    <div class="section bg-light">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <p class="section-subtitle">
          上海臻晅信息科技有限公司是一家专注于教育信息化的高科技企业，致力于为教育局与学校提供多方位的信息化解决方案。通过创新技术和优质服务，我们帮助教育机构实现数字化转型，提升管理效率和教学质量。
        </p>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="8" :md="8" class="feature">
            <div class="icon">
              <i class="el-icon-s-platform"></i>
            </div>
            <h3>专业团队</h3>
            <p>拥有多年行业经验的技术专家和教育领域顾问，深入理解教育行业需求</p>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" class="feature">
            <div class="icon">
              <i class="el-icon-s-cooperation"></i>
            </div>
            <h3>创新技术</h3>
            <p>应用前沿技术，提供安全、高效、易用的教育信息化解决方案</p>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" class="feature">
            <div class="icon">
              <i class="el-icon-service"></i>
            </div>
            <h3>优质服务</h3>
            <p>提供全方位的实施、培训和售后服务，确保系统高效运行</p>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 产品服务 -->
    <div class="section">
      <div class="container">
        <h2 class="section-title">我们的解决方案</h2>
        <p class="section-subtitle">覆盖教育局与学校多种应用场景，全方位助力教育信息化建设</p>
      </div>
    </div>

    <div class="section bg-light">
      <div class="container">
        <h3 class="product-category">教育局数据赋能</h3>
        <el-row :gutter="30" class="product-row">
          <el-col :xs="24" :sm="12" :md="8" v-for="(product, index) in featuredBureauProducts" :key="index">
            <el-card class="product-card" shadow="hover" @click.native="$router.push(product.link)">
              <div class="product-icon" :style="{ backgroundColor: product.color }">
                <i :class="product.icon"></i>
              </div>
              <div class="product-info">
                <h3>{{ product.title }}</h3>
                <p>{{ product.description }}</p>
                <el-button type="text" @click.stop>查看详情</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div class="view-more-container">
          <el-button type="primary" @click="$router.push('/products?tab=bureau')" class="view-more-btn">
            查看全部教育局解决方案 <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </div>
    </div>

    <div class="section" style="background-color: #f0f7ff;">
      <div class="container">
        <h3 class="product-category">智慧校园解决方案</h3>
        <el-row :gutter="30" class="product-row">
          <el-col :xs="24" :sm="12" :md="8" v-for="(product, index) in featuredSchoolProducts" :key="index">
            <el-card class="product-card" shadow="hover" @click.native="$router.push(product.link)">
              <div class="product-icon" :style="{ backgroundColor: product.color }">
                <i :class="product.icon"></i>
              </div>
              <div class="product-info">
                <h3>{{ product.title }}</h3>
                <p>{{ product.description }}</p>
                <el-button type="text" @click.stop>查看详情</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div class="view-more-container">
          <el-button type="primary" @click="$router.push('/products?tab=school')" class="view-more-btn">
            查看全部校园解决方案 <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </div>
    </div>

    <!-- 客户案例 -->
    <div class="section bg-light">
      <div class="container">
        <h2 class="section-title">成功案例</h2>
        <p class="section-subtitle">我们已为上海市静安区教育局和多所中小学提供信息化解决方案，赢得了广泛好评</p>
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="12" v-for="(case_, index) in cases" :key="index">
            <el-card class="case-card" shadow="hover" @click.native="$router.push(case_.link)">
              <div class="case-image" :style="{ backgroundColor: case_.color }"></div>
              <div class="case-content">
                <h3>{{ case_.title }}</h3>
                <p class="case-desc">{{ case_.description }}</p>
                <div class="case-footer">
                  <span>{{ case_.customer }}</span>
                  <el-button type="text" @click.stop>了解更多</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

<!--    &lt;!&ndash; 合作伙伴 &ndash;&gt;-->
<!--    <div class="section">-->
<!--      <div class="container">-->
<!--        <h2 class="section-title">合作伙伴</h2>-->
<!--        <p class="section-subtitle">携手优质合作伙伴，共同推进教育信息化建设</p>-->
<!--        <div class="partners-grid">-->
<!--          <div class="partner-item" v-for="i in 10" :key="i">-->
<!--            <img :src="require(`@/assets/images/partner${i}.png`)" :alt="`合作伙伴${i}`">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="section">
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        <p class="section-subtitle">携手优质合作伙伴，共同推进教育信息化建设</p>
        <div class="partners">
          <el-row :gutter="30">
            <el-col :xs="12" :sm="8" :md="4" v-for="i in 12" :key="i">
              <div class="partner-logo" :style="{ backgroundColor: '#f5f7fa' }">
                <img :src="require(`@/assets/images/partner${i}.png`)" alt="合作伙伴" />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
<!--    <div class="section contact-section">-->
<!--      <div class="container">-->
<!--        <h2 class="section-title">联系我们</h2>-->
<!--        <p class="section-subtitle">如有任何问题或项目需求，欢迎随时与我们联系</p>-->
<!--        <el-row :gutter="30">-->
<!--          <el-col :xs="24" :sm="12">-->
<!--            <div class="contact-info">-->
<!--              <div class="contact-item">-->
<!--                <i class="el-icon-location"></i>-->
<!--                <div>-->
<!--                  <h4>地址</h4>-->
<!--                  <p>上海市嘉定区德富路1090号宝龙广场5号楼502室</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="contact-item">-->
<!--                <i class="el-icon-phone"></i>-->
<!--                <div>-->
<!--                  <h4>电话</h4>-->
<!--                  <p>400-123-4567</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="contact-item">-->
<!--                <i class="el-icon-message"></i>-->
<!--                <div>-->
<!--                  <h4>邮箱</h4>-->
<!--                  <p>contact@example.com</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :xs="24" :sm="12">-->
<!--            <contact-form-->
<!--              title="联系我们"-->
<!--              description="如有任何问题或项目需求，欢迎随时与我们联系"-->
<!--              @submit-success="handleSubmitSuccess"-->
<!--            />-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
//import ContactForm from '@/components/ContactForm.vue'

export default {
  name: 'Home',
  // components: {
  //   ContactForm
  // },
  data() {
    return {
      eduBureauProducts: [
        {
          title: '预算系统',
          description: '智能预算管理，优化资源分配，提高教育经费使用效率',
          icon: 'el-icon-money',
          color: '#FF6B6B',
          link: '/products?type=budget'
        },
        {
          title: '资产系统',
          description: '智慧资产管理，实时监控资产状态，提高资产利用率',
          icon: 'el-icon-s-grid',
          color: '#4ECDC4',
          link: '/products?type=asset'
        },
        {
          title: '人力资源系统',
          description: '高效人事管理，简化行政流程，提升教师队伍建设',
          icon: 'el-icon-user',
          color: '#FFD166',
          link: '/products?type=hr'
        },
        {
          title: '内审系统',
          description: '规范内部审计流程，提高财务管理透明度和合规性',
          icon: 'el-icon-document-checked',
          color: '#06AED5',
          link: '/products?type=audit'
        },
        {
          title: '三段式课后服务系统',
          description: '一站式管理课后服务，提升学生课后时间利用效率',
          icon: 'el-icon-time',
          color: '#FF9E00',
          link: '/products?type=after-school'
        },
        {
          title: '学生资助系统',
          description: '精准管理学生资助项目，确保资助公平有效',
          icon: 'el-icon-coin',
          color: '#8338EC',
          link: '/products?type=student-aid'
        },
        {
          title: '项目申报',
          description: '简化项目申报流程，提高审批效率和透明度',
          icon: 'el-icon-s-order',
          color: '#FB5607',
          link: '/products?type=project-application'
        },
        {
          title: '文件收发系统',
          description: '高效管理文件流转，提升行政办公效率',
          icon: 'el-icon-document',
          color: '#3A86FF',
          link: '/products?type=document-system'
        },
        {
          title: '智慧文献数据云系统',
          description: '集中管理教育文献资源，便捷检索和共享',
          icon: 'el-icon-reading',
          color: '#4361EE',
          link: '/products?type=literature-cloud'
        },
        {
          title: '设备调拨台账系统',
          description: '精确管理设备调拨，提高资源利用效率',
          icon: 'el-icon-s-cooperation',
          color: '#4CC9F0',
          link: '/products?type=equipment-transfer'
        },
        {
          title: '教育局大数据系统',
          description: '多维度收集和分析教育数据，辅助决策和规划',
          icon: 'el-icon-data-analysis',
          color: '#560BAD',
          link: '/products?type=big-data'
        }
      ],
      schoolProducts: [
        {
          title: '教师在线学习平台',
          description: '丰富的在线资源，促进教师专业发展与成长',
          icon: 'el-icon-reading',
          color: '#118AB2',
          link: '/products?type=teacher'
        },
        {
          title: '学生活动平台',
          description: '丰富多彩的课外活动管理，助力学生多元成长',
          icon: 'el-icon-data-board',
          color: '#06D6A0',
          link: '/products?type=activity'
        },
        {
          title: '学生争章平台',
          description: '激励学生成长，形成良好学习氛围',
          icon: 'el-icon-medal',
          color: '#EF476F',
          link: '/products?type=badge'
        },
        {
          title: '成绩分析系统',
          description: '智能分析学生成绩，提供精准教学指导',
          icon: 'el-icon-s-data',
          color: '#073B4C',
          link: '/products?type=grade'
        },
        {
          title: '学生评价系统',
          description: '多维评价学生发展，促进个性化成长',
          icon: 'el-icon-s-claim',
          color: '#118AB2',
          link: '/products?type=evaluation'
        },
        {
          title: '在线商城',
          description: '便捷购买教育资源，提升学习体验',
          icon: 'el-icon-shopping-cart-full',
          color: '#FB5607',
          link: '/products?type=shop'
        },
        {
          title: '回家作业平台',
          description: '智能管理学生作业，提高教学效率和学习效果',
          icon: 'el-icon-notebook-1',
          color: '#FF006E',
          link: '/products?type=homework'
        },
        {
          title: '选课平台',
          description: '灵活的选课系统，满足个性化学习需求',
          icon: 'el-icon-s-management',
          color: '#8338EC',
          link: '/products?type=course-selection'
        },
        {
          title: '全员导师平台',
          description: '构建师生互动平台，促进个性化指导和成长',
          icon: 'el-icon-user-solid',
          color: '#3A86FF',
          link: '/products?type=mentor'
        },
        {
          title: '校园圈',
          description: '构建校园社交网络，促进师生交流与信息共享',
          icon: 'el-icon-chat-dot-round',
          color: '#7209B7',
          link: '/products?type=campus-circle'
        },
        {
          title: '电子班牌',
          description: '智能电子班牌系统，展示班级风采和信息',
          icon: 'el-icon-monitor',
          color: '#4CC9F0',
          link: '/products?type=e-class-sign'
        },
        {
          title: '课务系统',
          description: '高效管理课程安排，优化教学资源配置',
          icon: 'el-icon-date',
          color: '#4361EE',
          link: '/products?type=course-management'
        },
        {
          title: '师生考勤系统',
          description: '智能考勤管理，提高校园管理效率',
          icon: 'el-icon-alarm-clock',
          color: '#F72585',
          link: '/products?type=attendance'
        },
        {
          title: '会议系统',
          description: '便捷的会议预约和管理，提高沟通效率',
          icon: 'el-icon-s-flag',
          color: '#560BAD',
          link: '/products?type=meeting'
        },
        {
          title: '工资系统',
          description: '精确计算和管理教职工薪资，提高人事管理效率',
          icon: 'el-icon-wallet',
          color: '#F77F00',
          link: '/products?type=salary'
        },
        {
          title: '公开课管理平台',
          description: '系统化管理公开课资源，促进教学交流与提升',
          icon: 'el-icon-video-camera',
          color: '#2B9348',
          link: '/products?type=open-class'
        },
        {
          title: '师生订餐系统',
          description: '便捷的校园订餐服务，提升师生用餐体验',
          icon: 'el-icon-food',
          color: '#FF9E00',
          link: '/products?type=food-order'
        },
        {
          title: 'OA办公系统',
          description: '一站式校园办公自动化系统，提高行政效率',
          icon: 'el-icon-office-building',
          color: '#0077B6',
          link: '/products?type=oa'
        }
      ],
      cases: [
        {
          title: '上海市静安区教育局智慧教育平台',
          description: '为教育局构建了一体化的智慧教育平台，整合预算、资产、人事系统，提升管理效率',
          customer: '上海市静安区教育局',
          color: '#3A86FF',
          link: '/products?type=budget'
        },
        {
          title: '上海市多所中学信息化建设',
          description: '为学校打造了包括成绩分析、学生评价等多个系统的整体解决方案，教学质量显著提升',
          customer: '上海市多所中小学',
          color: '#8338EC',
          link: '/products?type=grade'
        }
        // ,
        // {
        //   title: '广州市某教育集团数字化转型',
        //   description: '针对教育集团特点，定制了集团化管理解决方案，实现了资源共享和统一管理',
        //   customer: '广州市教育集团',
        //   color: '#FF006E',
        //   link: '/products?type=asset'
        // }
      ]
    }
  },
  computed: {
    // 精选教育局产品（只展示3个）
    featuredBureauProducts() {
      // 选择最具代表性的三个产品
      return [
        this.eduBureauProducts[0], // 预算系统
        this.eduBureauProducts[2], // 人力资源系统
        this.eduBureauProducts[10] // 教育局大数据系统
      ];
    },
    // 精选学校产品（只展示3个）
    featuredSchoolProducts() {
      // 选择最具代表性的三个产品
      return [
        this.schoolProducts[3], // 成绩分析系统
        this.schoolProducts[6], // 回家作业平台
        this.schoolProducts[11] // 课务系统
      ];
    }
  },
  methods: {
    handleSubmitSuccess() {
      // 可以在这里处理表单提交成功后的逻辑
      console.log('表单提交成功');
    }
  }
}
</script>

<style scoped>
.banner {
  margin-bottom: 50px;
}
.carousel-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.carousel-text {
  text-align: center;
}
.carousel-text h1 {
  font-size: 3.2rem;
  margin-bottom: 1.2rem;
  font-weight: 700;
  text-shadow: 0 2px 8px rgba(0,0,0,0.2);
}
.carousel-text h3 {
  font-size: 1.6rem;
  margin-bottom: 2.5rem;
  font-weight: 400;
  text-shadow: 0 1px 4px rgba(0,0,0,0.15);
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.bg-light {
  background-color: #f8f9fa;
}

.feature {
  text-align: center;
  padding: 30px 20px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
  border-radius: 8px;
}
.feature:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  background-color: white;
}
.icon {
  font-size: 3.5rem;
  color: #1976D2;
  margin-bottom: 20px;
}
.feature h3 {
  margin-bottom: 15px;
  font-size: 1.4rem;
  font-weight: 600;
}

.product-category {
  text-align: center;
  margin: 40px 0 20px;
  color: #1976D2;
}
.product-row {
  margin-bottom: 30px;
}
.product-card {
  margin-bottom: 20px;
  height: 100%;
  transition: transform 0.3s, box-shadow 0.3s;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  padding: 25px;
  cursor: pointer;
}
.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(25, 118, 210, 0.1);
  border-color: rgba(25, 118, 210, 0.2);
}
.product-icon {
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: white;
  font-size: 1.8rem;
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}
.product-info h3 {
  margin-bottom: 12px;
  font-size: 1.3rem;
  font-weight: 600;
  color: #2C3E50;
}
.product-info p {
  color: #666;
  margin-bottom: 20px;
  font-size: 1rem;
  line-height: 1.6;
  flex-grow: 1;
  height: 80px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.view-more-container {
  text-align: center;
  margin: 20px 0 50px;
}

.view-more-btn {
  padding: 12px 25px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.view-more-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(25, 118, 210, 0.2);
}

.view-more-btn i {
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.view-more-btn:hover i {
  transform: translateX(3px);
}

.case-card {
  margin-bottom: 30px;
  height: 100%;
  transition: all 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.05);
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(25, 118, 210, 0.1);
  border-color: rgba(25, 118, 210, 0.2);
}
.case-image {
  height: 180px;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.case-image::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30%;
  background: linear-gradient(to top, rgba(0,0,0,0.5), transparent);
}
.case-content {
  padding: 20px;
  background-color: white;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.case-content h3 {
  margin-bottom: 12px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}
.case-desc {
  color: #666;
  margin-bottom: 15px;
  font-size: 0.95rem;
  min-height: 65px;
  overflow: hidden;
  line-height: 1.6;
  flex: 1;
}
.case-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999;
  margin-top: auto;
}

.contact-section {
  background-color: #f8f9fa;
}
.contact-info {
  margin-bottom: 30px;
}
.contact-item {
  display: flex;
  margin-bottom: 25px;
}
.contact-item i {
  font-size: 1.8rem;
  color: #1976D2;
  margin-right: 20px;
  width: 40px;
  text-align: center;
}
.contact-item h4 {
  margin-bottom: 5px;
  font-size: 1.1rem;
}
.contact-item p {
  color: #666;
}

/* 合作伙伴样式 */
.partners-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;
  margin: 40px 0;
}

.partner-item {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.partner-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.partner-item img {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;
}

.partner-item:hover img {
  filter: grayscale(0%);
  opacity: 1;
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .partners-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 991px) {
  .partners-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 767px) {
  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 480px) {
  .partners-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
.partners {
  margin-top: 40px;
}

.partner-logo {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  margin-bottom: 30px;
  padding: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.partner-logo:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.partner-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

@media (max-width: 767px) {
  .partner-logo {
    height: 80px;
    margin-bottom: 20px;
  }
}
</style>
